import { render, staticRenderFns } from "./historyList.vue?vue&type=template&id=21b7cd4d&scoped=true"
import script from "./historyList.vue?vue&type=script&lang=js"
export * from "./historyList.vue?vue&type=script&lang=js"
import style0 from "./historyList.vue?vue&type=style&index=0&id=21b7cd4d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b7cd4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21b7cd4d')) {
      api.createRecord('21b7cd4d', component.options)
    } else {
      api.reload('21b7cd4d', component.options)
    }
    module.hot.accept("./historyList.vue?vue&type=template&id=21b7cd4d&scoped=true", function () {
      api.rerender('21b7cd4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/tool/haishAssessment/components/historyList.vue"
export default component.exports